import React from "react";
import { Switch } from "@shared/ui/switch";
import { useGetMeterReadMethods, usePutMeterReadMethod } from "@features/mx/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";

export function ReadMethodsTab() {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: readMethodsData } = useGetMeterReadMethods(remoteUtilityId);
  const { mutate: updateMethod } = usePutMeterReadMethod();

  const toggleMethod = (id: number, currentActive: boolean) => {
    updateMethod({
      id,
      payload: { is_active: !currentActive },
    });
  };

  return (
    <div className="space-y-4 w-full">
      <p className="text-sm text-gray-500">
        Enable or disable the meter reading methods available in this system.
      </p>
      {readMethodsData?.map((item: any) => {
        const isActive = item.isActive !== undefined ? item.isActive : item.is_active;
        return (
          <div
            key={item.id}
            className="flex items-center justify-between p-5 bg-white border border-gray-150 rounded-xl shadow-sm transition-all hover:shadow-md"
          >
            <div className="space-y-1">
              <h4 className="text-sm font-semibold text-gray-800">{item.name}</h4>
              <p className="text-xs text-gray-500">{item.description}</p>
            </div>
            <Switch
              checked={isActive}
              onCheckedChange={() => toggleMethod(item.id, isActive)}
            />
          </div>
        );
      })}
    </div>
  );
}
export default ReadMethodsTab;
